(() => {
  'use strict';
  const dialog = document.getElementById('prem-welcome-dialog');
  if (!dialog || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const close = dialog.querySelector('[data-pwp-close]');
  const eventLink = dialog.querySelector('[data-pwp-event]');
  const storageKey = 'prem.social-event.last-shown.v1' + (window.Shopify?.theme?.role === 'unpublished' ? '.' + window.Shopify.theme.id : '');
  let lastShown = 0;
  let previousFocus = null;
  function readShown() {
    let stored = 0;
    try { stored = Number(localStorage.getItem(storageKey)); } catch {}
    if (!stored) {
      const cookie = document.cookie.split('; ').find(value => value.startsWith(storageKey + '='));
      stored = Number(cookie?.split('=')[1]);
    }
    return Math.max(lastShown, Number.isFinite(stored) ? stored : 0);
  }
  function enter() {
    if (dialog.open) dialog.close();
    const now = Date.now();
    const previous = readShown();
    dialog.dataset.checked = 'true';
    if (previous > 0 && now >= previous && now - previous < 600000) return;
    previousFocus = document.activeElement;
    dialog.showModal();
    lastShown = now;
    try { localStorage.setItem(storageKey, String(now)); } catch {}
    document.cookie = storageKey + '=' + now + '; Max-Age=600; Path=/; SameSite=Lax; Secure';
  }
  close.addEventListener('click', () => dialog.close());
  eventLink.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    if (previousFocus?.isConnected) previousFocus.focus({preventScroll: true});
  });
  enter();
})();
